import { useEffect, useState } from "react";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import {
  downloadQrPng,
  downloadQrSvg,
  generateQrPngDataUrl,
  PREVIEW_PNG_SIZE,
} from "./utils/qrCodeUtils";
import styles from "./QrCodePreview.module.scss";

interface IQrCodePreviewProps {
  /** The stable URL encoded into the QR (the backend-provided redirectUrl). */
  value: string;
  /** Human label used as the download file name. */
  name: string;
  size?: number;
}

export const QrCodePreview = ({
  value,
  name,
  size = PREVIEW_PNG_SIZE,
}: IQrCodePreviewProps) => {
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    generateQrPngDataUrl(value, size)
      .then((url) => {
        if (!cancelled) {
          setPreviewUrl(url);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPreviewUrl("");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [value, size]);

  const handleDownload = async (kind: "svg" | "png") => {
    setIsDownloading(true);
    try {
      if (kind === "svg") {
        await downloadQrSvg(value, name);
      } else {
        await downloadQrPng(value, name);
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className={styles.preview}>
      {previewUrl ? (
        <img
          className={styles.preview_image}
          src={previewUrl}
          alt={`QR код: ${name}`}
          width={size}
          height={size}
        />
      ) : (
        <div className={styles.preview_placeholder} />
      )}

      <div className={styles.preview_actions}>
        <DefaultButton
          label="SVG"
          design="outline"
          width="auto"
          loading={isDownloading}
          tooltip="Векторен файл — идеален за печат на голям формат"
          onClick={() => handleDownload("svg")}
        />
        <DefaultButton
          label="PNG"
          design="outline"
          width="auto"
          loading={isDownloading}
          tooltip="Висока резолюция (2048px) за печат"
          onClick={() => handleDownload("png")}
        />
      </div>
    </div>
  );
};
